/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class LocalStorageBanner extends React.Component {
    render() {
        return (
            <div>
                <div className="icon-wrapper">
                    <i className="fa fa-warning banner-icon"/>
                </div>
                <span>Private browsing disables some dlvr.it functionality. <a href="https://support.dlvrit.com/hc/en-us/articles/222385487" target="_blank">{"Learn more >>"}</a></span>
            </div>
        );
    }

};

LocalStorageBanner.displayName = "LocalStorageBanner";

export default LocalStorageBanner;
